import { useTranslations } from 'next-intl';
import { Text } from '@mentimeter/ragnar-ui/text';

export const Public = () => {
  const t = useTranslations('presenting');
  return (
    <Text color="text" lineHeight="heading" fontFamily="heading" fontSize={12}>
      {t('questions_from_audience.questions_from_audience_message')}
    </Text>
  );
};
